// this is an autogenerated file from App/Account/Chairs/Content/Appointments/Content/Appointment/Actions/ChangeChair/Content/Provider/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Chairs_Content_Appointments_Content_Appointment_Actions_ChangeChair_Content_Provider($current_location_id: uuid!) {
  vaxiom_employee_resources(
    where: {
      invalid: { _eq: false }
      resource: {
        organization: { _id: { _eq: $current_location_id } }
        resource_type: { is_provider: { _eq: true } }
        deleted: { _eq: false }
      }
      employment_contract: { employment_end_date: { _is_null: true } }
    }
    order_by: {
      employment_contract: { person: { first_name: asc, last_name: asc } }
    }
  ) {
    id
    employment_contract {
      id
      person {
        id
        first_name
        last_name
      }
    }
  }
}

`